export enum SdkSettingsTab {
  Bundles = "bundles",
  Scripts = "scripts",
}

export enum SdkSearchParams {
  Search = "q",
  Modal = "modal",
  Id = "id",
}

export enum SdkModalType {
  Create = "create",
  Edit = "edit",
  Delete = "delete",
}

export const clearSdkModalParams = (
  params: URLSearchParams,
): URLSearchParams => {
  params.delete(SdkSearchParams.Modal);
  params.delete(SdkSearchParams.Id);
  return params;
};
